export default class Header {
	constructor() {
		this.header = document.querySelector("header");
		this.menu = document.querySelector(".btnMobileMenu");
		this.menuOpen = document.querySelector(".menu-principal-container");
		this.searchToggle = document.querySelector(".site-header__search-toggle");
		this.searchPanel = document.querySelector(".global-search");

		this.initSearch();
		this.initSubmenu();
		this.initTheme();
		this.ready();
		this.scroll();
	}

	initTheme() {
		const root = document.documentElement;

		try {
			if (localStorage.getItem("tribuna-theme") === "dark") {
				root.classList.add("is-dark");
			}
		} catch (error) { /* storage indisponível */ }

		const sync = (dark) => {
			document.querySelectorAll(".theme-toggle").forEach((button) => {
				button.setAttribute("aria-pressed", dark ? "true" : "false");
				button.setAttribute("aria-label", dark ? "Ativar modo claro" : "Ativar modo escuro");
				const label = button.querySelector(".theme-toggle__text");
				if (label) {
					label.textContent = dark ? "Modo claro" : "Modo escuro";
				}
			});
			try { localStorage.setItem("tribuna-theme", dark ? "dark" : "light"); } catch (error) { }
		};
		sync(root.classList.contains("is-dark"));

		document.addEventListener("click", (event) => {
			if (event.target.closest && event.target.closest(".theme-toggle")) {
				sync(root.classList.toggle("is-dark"));
			}
		}, false);
	}

	initSearch() {
		// Ligação por delegação: funciona independente da ordem de carregamento/re-render.
		if (!this.searchToggle || !this.searchPanel) {
			return;
		}

		document.addEventListener("click", (event) => {
			if (event.target.closest && event.target.closest(".site-header__search-toggle")) {
				this.searchPanel.hidden ? this.openSearch() : this.closeSearch();
			}
		}, false);

		document.addEventListener("keydown", (event) => {
			if (event.key !== "Escape") {
				return;
			}
			if (!this.searchPanel.hidden) {
				this.closeSearch();
				this.searchToggle.focus();
				return;
			}
			if (this.menuOpen && this.menuOpen.classList.contains("active")) {
				this.closeMobileMenu();
				this.menu.focus();
			}
		}, false);
	}

	openSearch() {
		this.closeMobileMenu();
		this.searchPanel.hidden = false;
		this.searchToggle.setAttribute("aria-expanded", "true");
		const input = this.searchPanel.querySelector(".search-field__input");
		if (input) {
			window.setTimeout(() => input.focus(), 0);
		}
	}

	closeSearch() {
		if (!this.searchPanel || this.searchPanel.hidden) {
			return;
		}
		this.searchPanel.hidden = true;
		this.searchToggle.setAttribute("aria-expanded", "false");
	}

	closeMobileMenu() {
		this.setMobileMenuState(false);
	}

	setMobileMenuState(open) {
		if (!this.menu || !this.menuOpen) {
			return;
		}

		this.menuOpen.classList.toggle("active", open);
		this.menu.classList.toggle("active", open);
		this.menu.setAttribute("aria-expanded", open ? "true" : "false");
		this.menu.setAttribute("aria-label", open ? "Fechar menu" : "Abrir menu");

		if (!open) {
			this.menuOpen.classList.remove("is-sub");
		}
	}

	initSubmenu() {
		const container = document.querySelector(".menu-principal-container");
		if (!container) {
			return;
		}

		let panel = container.querySelector(".mobile-menu__subpanel");
		if (!panel) {
			panel = document.createElement("div");
			panel.className = "mobile-menu__subpanel";
			panel.setAttribute("role", "group");
			panel.setAttribute("aria-label", "Submenu");
			container.appendChild(panel);
		}

		panel.addEventListener("click", (event) => {
			if (event.target.closest(".mobile-menu__back")) {
				container.classList.remove("is-sub");
			}
		}, false);

		container.querySelectorAll(".site-header__menu > li.menu-item-has-children > a").forEach((link) => {
			link.addEventListener("click", (event) => {
				// Mantém o comportamento de desktop (link + submenu no hover).
				if (window.innerWidth >= 1024) {
					return;
				}
				event.preventDefault();
				const li = link.parentElement;
				const sub = li.querySelector(":scope > ul");
				if (!sub) {
					return;
				}
				this.fillSubpanel(panel, link, sub);
				container.classList.add("is-sub");
			}, false);
		});

		// Ao voltar para o desktop, reseta o drill-down.
		window.addEventListener("resize", () => {
			if (window.innerWidth >= 1024) {
				container.classList.remove("is-sub");
			}
		});
	}

	fillSubpanel(panel, link, sub) {
		panel.innerHTML = "";

		const back = document.createElement("button");
		back.type = "button";
		back.className = "mobile-menu__back";
		back.setAttribute("aria-label", "Voltar");
		back.textContent = "Voltar";

		const title = document.createElement("span");
		title.className = "mobile-menu__subtitle";
		title.textContent = link.textContent.trim();

		const list = document.createElement("ul");
		list.className = "mobile-menu__list";
		sub.querySelectorAll("li").forEach((item) => list.appendChild(item.cloneNode(true)));

		panel.appendChild(back);
		panel.appendChild(title);
		panel.appendChild(list);
	}

	ready() {

		if (this.menu && this.menuOpen) {
			this.menu.addEventListener("click", () => {
				this.closeSearch();
				this.setMobileMenuState(!this.menuOpen.classList.contains("active"));
			}, false);
		}

		document.querySelectorAll('.single-copy-link').forEach((button) => {
			button.addEventListener('click', async () => {
				try {
					await navigator.clipboard.writeText(button.dataset.url);
					button.classList.add('is-copied');
					button.setAttribute('aria-label', 'Link copiado');
					window.setTimeout(() => button.classList.remove('is-copied'), 1800);
				} catch (error) {
					window.prompt('Copie o link da notícia:', button.dataset.url);
				}
			});
		});

	}

	scroll() {

		let lastScrollTop = 0;

		window.addEventListener('scroll', () => {
			let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (currentScrollTop > 60) {
				this.header.classList.add('showHeader');

			} else {
				this.header.classList.remove('showHeader');
			}

			lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
		});

	}
}

new Header();
